import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from 'src/app/core/base/base.component';
import { GeneralHistoryViewModel } from 'src/app/model/general/history.view';
import { HISTORY_FAMILY_CONSTANTS } from './history-family.constants';
import { HistoryFamilyService } from './history-family.service';

@Component({
  selector: 'ms-history-family',
  templateUrl: './history-family.component.html',
  styleUrls: ['../history.styles.scss'],
})
export class HistoryFamilyComponent extends BaseComponent {
  readonly screen = HISTORY_FAMILY_CONSTANTS;
  @Input() hasComplete = false;
  @Input() mainDetail? = '';
  @Output() mainDetailChange = new EventEmitter<string | undefined>();
  histories: GeneralHistoryViewModel[] = [];
  showDetails = false;
  expandSection = true;

  constructor(protected service: HistoryFamilyService) {
    super();
  }

  onInit = () =>
    this.subscriptions.push(
      this.service
        .getHistories()
        .subscribe((histories) => (this.histories = histories)),
      this.service.getPersonId().subscribe((person) => {
        if (person != null) {
          this.subscriptions.push(
            this.service.loadHistories(person).subscribe()
          );
        }
      }),
      this.service.isSaving().subscribe((saving) => {
        if (saving) {
          const histories: GeneralHistoryViewModel[] = [];
          const edited = this.histories.filter(
            (history) => history.details && history.details.length > 0
          );
          histories.push(...edited);
          if (histories.length > 0) {
            this.subscriptions.push(
              this.service.save(histories, this.hasComplete).subscribe()
            );
          } else {
            this.service.addToSaved(this.hasComplete);
          }
        }
      })
    );

  handleDescriptionChange = () => this.mainDetailChange.emit(this.mainDetail);

  get historiesName() {
    return this.histories
      .filter((item) => item.details && item.details?.trim().length > 0)
      .map((item) => item.name)
      .join('; ');
  }
}
